/**
 * Notification service — active implementation selector.
 *
 * FRONTEND-ONLY (current): localStorage-backed.
 * BACKEND (later): swap the import for notificationService.api.js
 */

import notificationLocalService from './notificationService.local'
// import notificationApiService from './notificationService.api'

const notificationService = notificationLocalService
// const notificationService = notificationApiService

export default notificationService
